import * as React from "react";

function SvgComponent(props) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={24} 
      height={24} 
      viewBox="0 0 24 24"
      {...props}
    >
      <g data-name="Close Icon" fill="currentColor">
        <path 
          data-name="Line 1" 
          d="M18.36 6.64a1 1 0 0 1 0 1.41L13.41 12l4.95 4.95a1 1 0 1 1-1.41 1.41L12 13.41l-4.95 4.95a1 1 0 0 1-1.41-1.41L10.59 12 5.64 7.05a1 1 0 0 1 1.41-1.41L12 10.59l4.95-4.95a1 1 0 0 1 1.41 0z"
          style={{ transition: 'all 0.3s ease' }}
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
